<template>
  <div class="courses-list" :class="[$config.platform, $config.project]">
    <div class="hero-section">
      <div class="holder-hero-section container">
        <div class="row">
          <div class="holder-title col col-7">
            <h1 class="h3">
              Courses Library
            </h1>
            <p class="description">
              {{ $config.platform === 'fa' ? `Discover a content-rich curriculum to build your skillset from beginner to
              job - ready and achieve your finance career goals.Dive into expert - led lessons and gain practical
              insights.` : `Discover a content - rich data science curriculum designed to build your skillset from
              beginner to job - ready and help you achieve your data science career goals.` }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="container course-library">
      <div class="introduction">
        <h2 class="h4">
          {{ $c.text('pages.courses.title') }}
        </h2>
        <p>{{ $c.text('pages.courses.description') }}</p><br>
        <p>{{ $c.text('pages.courses.description2') }}</p>
      </div>
      <div class="row">
        <div v-if="$config.project === 'lms'" class="types-tabs col col-12">
          <div class="tabs" :class="{ 'three': tabs.length === 3 }">
            <template v-for="tab in tabs">
              <li
                v-if="tab.originalSize > 0 || tab.name === 'all' || (tab.name === 'my-courses' && $store.getters['auth/user'].simpleLms)" :key="tab.name"
                :class="[{ active: currentTab === tab.name }, tab.name]"
              >
                <a @click="changeTab(tab.name)">
                  <IconBasket v-if="tab.name === 'my-courses'" />
                  {{ tab.text }}
                  <template v-if="tab.name !== 'all' && tab.name !== 'my-courses'">
                    ({{ tab.size }})
                  </template>
                </a>
              </li>
            </template>
          </div>
        </div>
        <div class="col col-3 md-4">
          <FiltersAccordion
            v-if="$store.state.layout === 'desktop'" :filters="filters" :reset="filtersReset"
            :de-selected="deSelected" :class="{ 'lms-filters-accordion': $config.project === 'lms' }"
            @change="filtrate"
          />
        </div>
        <div class="col col-9 md-8">
          <div class="search">
            <div class="search-holder">
              <SearchBar
                :placeholder="$store.state.layout === 'mobile' ? 'Search' : 'Search courses'"
                :value="clearSearch" class="sm-10" @search="search"
              />
              <Filters
                v-if="$store.state.layout === 'mobile'" :filters="filters" :reset="filtersReset"
                :de-selected="deSelected" @change="filtrate"
              />
            </div>
            <SearchResults
              key="searchLabels" :filters="filters" :labels="searchLabels"
              @closeLabel="close"
              @clearAll="reset"
            />
          </div>
          <div class="row">
            <Card
              v-for="course in courses"
              :key="course.id" heading="h3" :course="course"
              class="col col-4 md-6 sm-6"
              :simple-lms="Boolean($store.getters['auth/user'].simpleLms)"
            >
              <template v-if="$store.getters['auth/user'].simpleLms" slot="button">
                <button v-if="course.pendingPayment" class="btn btn-dark-shade-4 progress action-btn">
                  Pending...
                  <Tooltip>
                    Payment being processed. This may take a few minutes.
                  </Tooltip>
                </button>
                <div v-else-if="course.label === 'free'" class="btn btn-primary action-btn">
                  Enroll Now
                </div>
                <template v-else-if="!course.purchased">
                  <span v-if="course.promo" class="promo">
                    <span class="percent-off">{{ course.percentOff }}% OFF</span> <span class="price">{{ course.currency.sign }}{{ course.originalPrice }}</span>
                  </span>
                  <div class="btn btn-primary action-btn">
                    Buy for {{ course.currency.sign }}{{ course.price || 99 }}
                  </div>
                </template>
                <nuxt-link v-else class="btn btn-primary-transparent action-btn progress" :to="`/courses/${course.slug}/`">
                  {{ course.progress ? 'Continue learning' : 'Start learning' }}
                </nuxt-link>
              </template>
            </Card>
          </div>
        </div>
      </div>
    </div>
    <slot name="banner" />
  </div>
</template>

<script>
import FiltersAccordion from './FiltersAccordion.vue';
import SearchResults from './SearchResults.vue';
import Filters from './CoursesFilters';
import SearchBar from './SearchBar';
import Card from './Card';
import global from '../mixins/global';
import IconBasket from '../assets/svg/icon-basket.svg?vue-component';
import Tooltip from '../components/Tooltip';

export default {
  components: {
    FiltersAccordion,
    SearchResults,
    Filters,
    Card,
    SearchBar,
    IconBasket,
    Tooltip,
  },
  mixins: [global],
  props: {
    list: { type: Object, required: false, default: () => ({}) },
    defaultTab: { type: String, required: false, default: '' },
  },
  data() {
    return {
      courses: this.list.courses || [],
      keyword: '',
      deSelectedOption: {},
      topics: this.list.topics || {},
      technologies: this.list.technologies || {},
      tracks: this.list.tracks || {},
      filter: null,
      searchLabels: {},
      coursesList: [],
      resetFilters: false,
      results: 0,
      page: {},
      currentTab: this.defaultTab || (this.$store.getters['auth/user'].simpleLms ? (this.$route.query.tab || 'my-courses') : (this.$route.query.tab || 'all')),
      tabs: [
        { name: 'all', text: 'All courses' },
        ...(!this.$store.getters['auth/user'].simpleLms ? [
          {
            name: 'in-progress', text: 'In progress', size: 0, originalSize: null,
          },
          {
            name: 'recommendations', text: 'Recommendations', size: 0, originalSize: null,
          },
          {
            name: 'completed', text: 'Completed', size: 0, originalSize: null,
          },
        ] : []),
        {
          name: 'my-courses', text: 'My courses', size: 1, originalSize: null,
        },
      ],
    };
  },
  // eslint-disable-next-line consistent-return
  async fetch() {
    try {
      let { courses, page, tabs } = this.list;

      if (!this.list.courses) {
        ({ courses, page, tabs } = await this.$axios.$get('/courses'));
      }

      page.fullPath = `${this.$config.siteUrl}${this.$route.fullPath}`;
      page.metaFullImageUrl = `${this.$config.siteUrl}/resources/${page.metaImage}`;
      page.metaImageDimensions = page.metaImageDimensions || {};
      page.created = this.dateIsoString(page.created || new Date());
      page.updated = this.dateIsoString(page.updated || new Date());

      courses.forEach((item, i) => {
        this.coursesList.push({
          '@type': 'ListItem',
          position: i + 1,
          url: `${this.$config.siteUrl}/courses/${item.slug}/`,
        });
      });

      if (tabs) {
        this.setTabSizes(tabs);
      }

      this.page = page;

      this.searchLabels = {
        results: courses.length,
        searchData: this.keyword,
        filtersData: {},
      };
    } catch (error) {
      console.log(error);
      return this.$router.push('/');
    }
  },
  head() {
    if (this.$config.project === 'site') {
      const linkedData = this.$linkedDataLoad([
        { key: 'WebSite' },
        { key: 'WebPage', values: { ...this.page } },
        {
          key: 'CoursesList',
          values: {
            '@context': 'https://schema.org',
            '@type': 'ItemList',
            itemListElement: this.coursesList || [],
          },
        },
      ]);

      const link = [];

      if (this.canonicalURL) {
        link.push({ rel: 'canonical', href: this.canonicalURL() });
      }

      return {
        titleTemplate: `${this.page.metaTitle}%s`,
        link,
        meta: this.metaProps(this.page),
        script: [linkedData],
      };
    }

    return { titleTemplate: `${this.page.metaTitle}%s`, meta: this.metaProps(this.page) };
  },
  computed: {
    filters() {
      const tracks = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.tracks)) {
        tracks[value] = { text: key, id: value };
      }

      // const topics = {};
      // // eslint-disable-next-line no-restricted-syntax
      // for (const [key, value] of Object.entries(this.topics)) {
      //   topics[value] = { text: key, id: value };
      // }
      const topics = Object.entries(this.topics).reduce((p, [k, v], i) => ({ ...p, [v.id]: { text: k, id: v.id, i: v.order } }), {});

      const technologies = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.technologies)) {
        technologies[value] = { text: key, id: value };
      }

      const duration = {
        '1-2': { text: '1-2 hours' },
        '3-4': { text: '3-4 hours' },
        '5-6': { text: '5-6 hours' },
        '7+': { text: '7+ hours' },
      };

      const difficulty = {
        0: { text: 'Beginner' },
        1: { text: 'Intermediate' },
        2: { text: 'Advanced' },
      };

      return {
        skill: {
          name: 'Topics',
          type: 'multiple',
          values: topics,
          open: true,
        },
        ...(this.$config.platform === 'ds' && {
          technology: {
            name: 'Technology',
            type: 'multiple',
            values: technologies,
            open: true,
          },
        }),
        difficulty: {
          name: 'Level of difficulty',
          type: 'multiple',
          values: difficulty,
          open: true,
        },
        duration: {
          name: 'Duration',
          type: 'multiple',
          values: duration,
          open: true,
        },
        track: {
          name: 'Career Track',
          type: 'single',
          values: tracks,
          open: true,
        },
      };
    },
    clearSearch() {
      return this.keyword;
    },
    deSelected() {
      return this.deSelectedOption;
    },
    filtersReset() {
      return this.resetFilters;
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.handleScroll);
      this.$once('hook:beforeDestroy', () => window.removeEventListener('scroll', this.handleScroll));
    });
  },
  methods: {
    async filtrate(f) {
      this.filter = f.params;
      await this.fetchCourses();
      this.searchLabels.filtersData = f.filter;
      this.resetFilters = false;
    },
    async search(k) {
      this.keyword = k;
      await this.fetchCourses();
    },
    close(label) {
      if (label.type === 'search') {
        this.keyword = '';
      } else {
        this.deSelectedOption = label;
      }
    },
    reset() {
      this.resetFilters = true;
    },
    async fetchCourses() {
      const { courses, tabs } = await this.$axios.$get(`/courses?location=${this.$config.project}&q=${this.keyword}${this.filter ? `&${this.filter}` : ''}${this.currentTab !== 'all' ? `&filter[tab]=${this.currentTab}` : ''}`, { progress: false });
      this.courses = courses;

      if (tabs) {
        this.setTabSizes(tabs);
      }

      this.searchLabels.results = this.courses.length;
      this.searchLabels.searchData = this.keyword;
    },
    expand(e) {
      const top = document.querySelector('.search');
      const middle = document.querySelector('.hidden');

      if (e.target.classList.value.includes('show-all')) {
        e.target.classList.remove('show-all');
        e.target.classList.add('hide-all');
        const hiddenCards = document.querySelectorAll('.hidden');
        hiddenCards.forEach((el) => {
          el.classList.remove('hidden');
          el.classList.add('visible');
        });
        middle.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      } else {
        e.target.classList.remove('hide-all');
        e.target.classList.add('show-all');
        const hiddenCards = document.querySelectorAll('.visible');
        hiddenCards.forEach((el) => {
          el.classList.remove('visible');
          el.classList.add('hidden');
        });
        top.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      }
    },
    async changeTab(tab) {
      this.currentTab = tab;
      await this.fetchCourses();
    },
    setTabSizes(tabs) {
      if (this.$config.project !== 'lms') {
        return;
      }

      this.tabs.forEach((tab, i) => {
        if (tab.name !== 'all' && (tabs[tab.name] || tabs[tab.name] === 0)) {
          this.tabs[i].size = +tabs[tab.name];

          if (tab.originalSize === null) {
            this.tabs[i].originalSize = +tabs[tab.name];
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
.courses-list {
  .hero-section {
    color: var(--main-light);
    background: linear-gradient(135deg, rgba(86, 191, 199, 0.2) 0.94%, rgba(86, 191, 199, 0) 100%), var(--main-dark);
    min-height: 212px;
    display: flex;
    align-items: center;
    margin-bottom: 64px;

    .h3 {
      margin-bottom: 0;
      line-height: 118%;
      font-weight: 600;
    }

    .description {
      padding-left: 0;
      line-height: 162%;
      color: var(--main-light-shade-4);
      margin-bottom: 0;
    }
  }

  &.site {
    .hero-section {
      padding-top: var(--spacing-80);
      min-height: 308px;

      .holder-title {
        .h3 {
          font-weight: 500;
          font-size: 40px;
          line-height: 110%;
        }

        p {
          line-height: 150%;
        }
      }
    }
  }

  .course-library {
    .introduction {
      margin-bottom: var(--spacing-60);

      h1 {
        line-height: 26px;
        font-weight: 500;
        font-size: 32px;
        text-transform: capitalize;
      }

      p {
        line-height: 150%;
        margin: 0;
        color: var(--main-dark-light-4);
      }
    }

    .types-tabs {
      margin-bottom: 48px;

      .tabs {
        list-style: none;
        padding: 0;
        margin: 0;
        display: flex;
        align-items: center;

        li {
          margin: 0;
          position: relative;
          min-width: 170px;
          text-align: center;

          a {
            color: var(--main-light-shade-4) !important;
            border-bottom: 3px solid var(--main-light-shade-4);
            padding-bottom: var(--spacing-8);
            text-decoration: none;
            font-weight: bold;
            cursor: pointer;
            display: block;
          }

          &.active a {
            color: var(--accent) !important;
            border-bottom-color: var(--accent);
          }

          &.my-courses {
            &.active,
            &:hover {
              a {
                color: var(--main-purple-dark-1) !important;
                border-bottom: 3px solid var(--main-purple-dark-1);

                svg {
                  path {
                    fill: var(--main-purple-dark-1);
                  }
                }
              }
            }

            a {
              display: flex;
              align-items: center;
              justify-content: center;
              color: var(--main-purple) !important;

              svg {
                margin-right: var(--spacing-8);
              }
            }
          }
        }
      }
    }

    .mobile-section-title {
      display: none;
    }

    .menus-wrapper {
      .menu {
        h5 {
          font-weight: 600;
        }

        ul {
          list-style: none;
          padding: 0;
          margin: 0;

          li {
            padding: var(--spacing-12) var(--spacing-14);
            padding-left: 2px;
            line-height: 24px;
            cursor: pointer;
            display: flex;
            align-items: center;
            overflow: hidden;

            &:hover {
              color: var(--accent);
              font-weight: 600;
            }

            &.active {
              color: var(--accent);
              font-weight: 600;
            }
          }
        }
      }
    }

    .title-section {
      display: none;
    }

    .lms-filters-accordion {
      .head {
        font-size: 16px;
        font-weight: 400;
        margin-bottom: var(--spacing-30);
        line-height: 27px;
        color: var(--main-dark-light-3);
      }

      .filters-dropdown {
        >div {
          .filter-name {
            font-size: 16px;
            font-weight: 400;
            line-height: 27px;
            color: var(--main-dark-light-3);
          }
        }
      }
    }
  }

  @include bp($bp-laptop) {
    &.site {
      .hero-section {
        .holder-title {
          .h3 {
            font-size: 32px;
          }
        }
      }

      .course-library .introduction h1 {
        font-size: 28px;
      }
    }

    .hero-section .holder-title {
      .h3 {
        font-size: 32px;
        line-height: 40px;
      }
    }
  }

  @include bp($bp-mobile) {
    &.site {
      .hero-section {
        min-height: 375px;
        padding-top: 68px;
        padding-bottom: 0;

        .holder-title {
          .h3 {
            font-size: 32px;
          }
        }
      }

      .course-library .search-holder {
        .search-bar input {
          height: 40px;
        }

        .search-bar-wrapper {
          margin-right: 17px;
        }

        .__filters {
          .filter-button {
            width: 40px;
            height: 40px;
          }
        }
      }
    }

    .hero-section {
      padding: var(--spacing-40) 0;

      .holder-title {
        .h3 {
          font-size: 32px;
        }
      }
    }

    .course-library {
      padding-bottom: var(--spacing-80);

      .search {
        padding-left: var(--spacing-12);
        padding-right: var(--spacing-12);
      }

      .types-tabs {
        margin-bottom: var(--spacing-36);
        padding-left: var(--spacing-24);
        padding-right: var(--spacing-24);

        .tabs {
          flex-direction: column;
          align-items: flex-start;

          li {
            width: 100%;

            a {
              text-align: left;
              border-bottom: 0;
              border-left: 3px solid var(--main-light-shade-4);
              padding: var(--spacing-12);
            }

            &.active a {
              color: var(--accent) !important;
              border-left-color: var(--accent);
            }

            &.my-courses {
              &.active {
                a {
                  border-left: 3px solid var(--main-purple-dark-1);
                  border-bottom: unset;
                }
              }

              a {
                justify-content: flex-start;
              }
            }
          }
        }
      }

      .mobile-section-title {
        display: block;
      }

      .menus-wrapper .menu {
        display: none;
      }

      .title-section {
        display: block;
        line-height: 120%;
        font-size: 21px;
        font-weight: 700;
        margin-top: var(--spacing-lg);
      }

      .search-holder {
        .search-bar input {
          height: 48px;
        }
      }
    }
  }

  &.lms .course-library .introduction h1 {
    font-weight: 600;
    font-size: 28px;

    @include bp($bp-laptop) {
      font-size: 24px;
    }
  }

  &.fa {
    .hero-section {
      background: linear-gradient(180deg, rgba(3, 111, 253, 0.14), rgba(3, 111, 253, 0.05) 25.75%, rgba(1, 22, 51, 0) 100%), #011633;
    }
  }
}
</style>
